<div class="">
  <span class="d-flex position-relative">
    <input
      class="month-picker ids-input--small"
      type="text"
      readonly
      (click)="calendarioIconeClick()"
      [ngModel]="model"
      placeholder="{{ placeHolder }}"
    />
    <ids-icon variant="primary" class="icone-calendario ids-icon--primary"
      >calendario_outline</ids-icon
    >
  </span>
</div>
<div
  id="containerDataPicker"
  class="container fdms-mes-selecao"
  *ngIf="mesSelecao.estado === 'aberto'"
>
  <div class="row container-ano">
    <div class="col-2">
      <span (click)="voltarAno()">
        <i class="fa fa-caret-left icon prev-ano"></i>
      </span>
    </div>
    <div class="col-8 text-center">
      <span style="font-weight: 600">{{ mesSelecao.displayAno }}</span>
    </div>
    <div class="col-2">
      <span (click)="proximoAno()">
        <i class="fa fa-caret-right icon prev-ano"></i>
      </span>
    </div>
  </div>
  <div class="row container-mes justify-content-center">
    <div
      class="col-auto selecao-item"
      *ngFor="let item of mesSelecao.selectionItems"
    >
      <button
        [disabled]="item.bloqueado"
        (click)="selecionarItemClick(item)"
        class="mes-item"
        [ngClass]="item.classItem"
      >
        {{ item.text }}
      </button>
    </div>
  </div>
</div>
